import { render, staticRenderFns } from "./TablePaginatedIncomes.vue?vue&type=template&id=442dd53b&scoped=true"
import script from "./TablePaginatedIncomes.vue?vue&type=script&lang=js"
export * from "./TablePaginatedIncomes.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedIncomes.vue?vue&type=style&index=0&id=442dd53b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442dd53b",
  null
  
)

export default component.exports